var map = {
	"./airfryer.png": 443,
	"./coffee.png": 825,
	"./dishwasher.png": 135,
	"./music.png": 105,
	"./smartphone.png": 738,
	"./tea.png": 765,
	"./toast.png": 916,
	"./tosti.png": 969,
	"./tree.png": 359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 375;